import { html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { tagName } from '../../helpers';

const tag = tagName('logo');

@customElement(tag)
export class LogoComponent extends TmElement {
  static override styles = [
    css`
      :host {
        display: block;
        line-height: 0;
      }

      :where(svg) {
        block-size: 100%;
        inline-size: auto;
      }
    `,
  ];

  override render() {
    return html`<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-10 -10 288 124"
      preserveAspectRatio="none"
    >
      <path
        stroke="#ffffff"
        stroke-width="14"
        fill="#008FD3"
        d="M61.4,50.6l21.7-28.4L21.8,15c-8.6-1-16,5.2-16.5,13.8L3.9,52.6c-0.5,8.6,5.8,17.8,14,20.4l46.2,14.7
C72.3,90.4,81.7,86,85,78l0.6-1.5l-19.2-7.6C58.5,65.7,56.2,57.4,61.4,50.6"
      />
      <path
        stroke="#ffffff"
        stroke-width="14"
        fill="#96BD0D"
        d="M117.1,33.3l6.9-10.4l-14.6-9.3c-7.3-4.7-17.5-2.9-22.7,4l-3.6,4.7l8.1,1c8.6,1,12.9,8.4,9.6,16.3l-15.2,37
l45.8,18.3c6.3,2.5,13.2,0.5,17.1-4.5L119.1,58C113.2,51.6,112.4,40.5,117.1,33.3"
      />
      <path
        stroke="#ffffff"
        stroke-width="14"
        fill="#008B36"
        d="M91.2,23.2l-8.1-1L61.4,50.6c-5.2,6.9-3,15.1,5.1,18.3l19.2,7.6l15.2-37C104.1,31.6,99.8,24.2,91.2,23.2"
      />
      <path
        stroke="#ffffff"
        stroke-width="14"
        fill="#E2004F"
        d="M173.5,26.1l-22-16.4c-6.9-5.2-16.5-3.5-21.2,3.7l-6.3,9.5l26.3,16.8c7.3,4.7,11,15.2,8.3,23.3L151,85.7
c-0.6,1.7-1.4,3.3-2.5,4.6l3.2,3.5c5.8,6.4,16.2,7.3,23,2l27.8-21.4l-27.6-35C171.4,35,171.1,30,173.5,26.1"
      />
      <path
        stroke="#ffffff"
        stroke-width="14"
        fill="#A31D23"
        d="M158.5,63.1c2.7-8.2-1-18.7-8.3-23.3L124,22.9l-6.9,10.4c-4.7,7.2-3.9,18.3,1.9,24.7l29.4,32.3
c1-1.3,1.9-2.9,2.5-4.6L158.5,63.1z"
      />
      <path
        stroke="#ffffff"
        stroke-width="14"
        fill="#F19300"
        d="M262,56l-22.2-43c-4-7.7-13.7-11.2-21.7-7.9l-38.4,16c-2.8,1.2-4.8,2.9-6.1,5l34,25.4c6.9,5.2,7,13.7,0.1,19
l-5.2,4l15.7,19.9c5.3,6.8,15,7.6,21.4,1.9l17.8-15.8C263.9,74.6,265.9,63.7,262,56"
      />
      <path
        stroke="#ffffff"
        stroke-width="14"
        fill="#CC071E"
        d="M207.5,51.4l-34-25.4c-2.4,3.9-2.1,8.9,1.4,13.4l27.6,35l5.2-4C214.5,65.1,214.4,56.6,207.5,51.4"
      />

      <path
        fill="#008FD3"
        d="M61.4,50.6l21.7-28.4L21.8,15c-8.6-1-16,5.2-16.5,13.8L3.9,52.6c-0.5,8.6,5.8,17.8,14,20.4l46.2,14.7
C72.3,90.4,81.7,86,85,78l0.6-1.5l-19.2-7.6C58.5,65.7,56.2,57.4,61.4,50.6"
      />
      <path
        fill="#96BD0D"
        d="M117.1,33.3l6.9-10.4l-14.6-9.3c-7.3-4.7-17.5-2.9-22.7,4l-3.6,4.7l8.1,1c8.6,1,12.9,8.4,9.6,16.3l-15.2,37
l45.8,18.3c6.3,2.5,13.2,0.5,17.1-4.5L119.1,58C113.2,51.6,112.4,40.5,117.1,33.3"
      />
      <path
        fill="#008B36"
        d="M91.2,23.2l-8.1-1L61.4,50.6c-5.2,6.9-3,15.1,5.1,18.3l19.2,7.6l15.2-37C104.1,31.6,99.8,24.2,91.2,23.2"
      />
      <path
        fill="#E2004F"
        d="M173.5,26.1l-22-16.4c-6.9-5.2-16.5-3.5-21.2,3.7l-6.3,9.5l26.3,16.8c7.3,4.7,11,15.2,8.3,23.3L151,85.7
c-0.6,1.7-1.4,3.3-2.5,4.6l3.2,3.5c5.8,6.4,16.2,7.3,23,2l27.8-21.4l-27.6-35C171.4,35,171.1,30,173.5,26.1"
      />
      <path
        fill="#A31D23"
        d="M158.5,63.1c2.7-8.2-1-18.7-8.3-23.3L124,22.9l-6.9,10.4c-4.7,7.2-3.9,18.3,1.9,24.7l29.4,32.3
c1-1.3,1.9-2.9,2.5-4.6L158.5,63.1z"
      />
      <path
        fill="#F19300"
        d="M262,56l-22.2-43c-4-7.7-13.7-11.2-21.7-7.9l-38.4,16c-2.8,1.2-4.8,2.9-6.1,5l34,25.4c6.9,5.2,7,13.7,0.1,19
l-5.2,4l15.7,19.9c5.3,6.8,15,7.6,21.4,1.9l17.8-15.8C263.9,74.6,265.9,63.7,262,56"
      />
      <path
        fill="#CC071E"
        d="M207.5,51.4l-34-25.4c-2.4,3.9-2.1,8.9,1.4,13.4l27.6,35l5.2-4C214.5,65.1,214.4,56.6,207.5,51.4"
      />
      <path
        fill="#FFFFFF"
        d="M68.3,53.5c0-3.8-2.2-6.7-6.1-6.7c-3.6,0-6.1,2.6-6.1,7.2c0,5.7,3.2,7.2,6.5,7.2c2.5,0,3.9-0.8,5.3-2.2
l-2.1-2.1c-0.9,0.9-1.6,1.3-3.2,1.3c-2,0-3.1-1.3-3.1-3.1h8.8V53.5z M59.6,52.7c0-0.6,0.1-1,0.3-1.5c0.4-0.8,1.2-1.5,2.3-1.5
s2,0.6,2.3,1.5c0.2,0.5,0.3,0.9,0.3,1.5H59.6z M105.7,53.5c0-3.8-2.2-6.7-6.1-6.7c-3.6,0-6.1,2.6-6.1,7.2c0,5.7,3.2,7.2,6.5,7.2
c2.5,0,3.9-0.8,5.3-2.2l-2.1-2.1c-0.9,0.9-1.6,1.3-3.2,1.3c-2,0-3.1-1.3-3.1-3.1h8.8L105.7,53.5L105.7,53.5z M96.9,52.7
c0-0.6,0.1-1,0.3-1.5c0.4-0.8,1.2-1.5,2.3-1.5c1.2,0,2,0.6,2.3,1.5c0.2,0.5,0.3,0.9,0.3,1.5H96.9z M137.4,51.2
c-0.4-0.8-1.2-1.5-2.3-1.5c-1.2,0-2,0.6-2.3,1.5c-0.2,0.5-0.3,0.9-0.3,1.5h5.3C137.7,52.1,137.6,51.7,137.4,51.2 M132.4,55.1
c0,1.8,1.1,3.1,3.1,3.1c1.5,0,2.3-0.4,3.2-1.3l2.1,2.1c-1.4,1.4-2.8,2.2-5.3,2.2c-3.3,0-6.5-1.5-6.5-7.2c0-4.6,2.5-7.2,6.1-7.2
c3.9,0,6.1,2.9,6.1,6.7v1.6L132.4,55.1L132.4,55.1z M175,51.2c-0.4-0.8-1.2-1.5-2.3-1.5c-1.2,0-2,0.6-2.3,1.5
c-0.2,0.5-0.3,0.9-0.3,1.5h5.3C175.3,52.1,175.2,51.7,175,51.2 M170,55.1c0,1.8,1.1,3.1,3.1,3.1c1.5,0,2.3-0.4,3.2-1.3l2.1,2.1
c-1.4,1.4-2.8,2.2-5.3,2.2c-3.3,0-6.5-1.5-6.5-7.2c0-4.6,2.5-7.2,6.1-7.2c3.9,0,6.1,2.9,6.1,6.7v1.6L170,55.1L170,55.1z M218.2,50.6
c-0.4-0.4-0.9-0.6-1.6-0.6c-0.7,0-1.2,0.2-1.6,0.6c-0.7,0.7-0.8,1.9-0.8,3.4s0.1,2.7,0.8,3.4c0.4,0.4,0.9,0.6,1.6,0.6
c0.7,0,1.2-0.2,1.6-0.6c0.7-0.7,0.8-2,0.8-3.4C219.1,52.6,219,51.3,218.2,50.6 M221,59.5c-0.9,0.9-2.3,1.7-4.4,1.7
c-2.1,0-3.5-0.8-4.3-1.7c-1.3-1.3-1.6-2.9-1.6-5.5c0-2.5,0.3-4.1,1.6-5.4c0.9-0.9,2.3-1.7,4.3-1.7c2.1,0,3.5,0.8,4.4,1.7
c1.3,1.3,1.6,2.9,1.6,5.4C222.6,56.6,222.2,58.2,221,59.5 M27.7,45.2V61h-3.7V45.2h-5v-3.3h13.8v3.3H27.7z M46.7,61V52
c0-3-1.6-5.1-4.7-5.1c-1.2,0-2.4,0.5-3.4,1.5v-6.4h-3.5V61h3.5v-8.6c0-1.8,1.2-2.5,2.3-2.5c1.1,0,2.3,0.6,2.3,2.5V61
C43.2,61,46.7,61,46.7,61z M49.9,61h3.5V47h-3.5V61z M49.9,44.6h3.6v-2.9h-3.6V44.6z M90.9,61v-9c0-1.5-0.4-2.9-1.5-4
c-0.8-0.8-2-1.2-3.4-1.2c-1.8,0-3,0.5-4.2,1.8c-0.9-1.2-2.2-1.8-3.7-1.8c-1.3,0-2.6,0.5-3.5,1.5V47h-3.4v14h3.5v-8.5
c0-1.9,1.2-2.6,2.3-2.6s2.3,0.6,2.3,2.6V61h3.5v-8.6c0-1.8,1.3-2.5,2.3-2.5c1.1,0,2.3,0.6,2.3,2.6V61L90.9,61L90.9,61z M126,61V41.9
h-3.7l-5,10.4l-5-10.4h-3.7V61h3.7V49.9l3.7,7.3h2.5l3.7-7.3V61C122.3,61,126,61,126,61z M155.4,61V47h-3.5v8.5
c0,1.9-1.2,2.6-2.3,2.6c-1.1,0-2.3-0.6-2.3-2.6V47h-3.5v9c0,1.5,0.3,2.9,1.4,4c0.8,0.8,1.9,1.2,3.3,1.2c1.3,0,2.6-0.5,3.5-1.5V61
H155.4z M164.8,61v-3h-1.3c-0.9,0-1.2-0.4-1.2-1.3V41.9h-3.5V57c0,2,1.2,4,4.1,4L164.8,61L164.8,61z M193.1,61v-9
c0-1.5-0.3-2.9-1.4-4c-0.8-0.8-1.9-1.2-3.3-1.2c-1.3,0-2.6,0.5-3.5,1.5V47h-3.4v14h3.5v-8.5c0-1.9,1.2-2.6,2.3-2.6
c1.1,0,2.3,0.6,2.3,2.6V61C189.6,61,193.1,61,193.1,61z M208,61V52c0-3-1.6-5.1-4.7-5.1c-1.2,0-2.4,0.5-3.4,1.5v-6.4h-3.5V61h3.5
v-8.6c0-1.8,1.2-2.5,2.3-2.5s2.3,0.6,2.3,2.5V61C204.5,61,208,61,208,61z M232,50.1v-2.7h-2.6v-1.5c0-0.8,0.4-1.3,1.2-1.3h1.4v-3h-2
c-2.9,0-4.1,2-4.1,4v1.8h-1.5v2.7h1.5v11h3.5v-11H232z M241.4,50.1v-2.7h-2.6v-1.5c0-0.8,0.4-1.3,1.2-1.3h1.4v-3h-2
c-2.9,0-4.1,2-4.1,4v1.8h-1.5v2.7h1.5v11h3.5v-11H241.4z"
      />
    </svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-logo': LogoComponent;
  }
}
